<template>
	<div class="container">
		<div v-if="showAddInvoiceItem" class="vx-row w-full mb-2">
			<div class="vx-col">
				<vs-select
					autocomplete
					v-model="product_id"
					class="select-large mt-4"
					placeholder="Prestation"
					label="Prestation"
				>
					<vs-select-item
						:key="index"
						:value="item.id"
						:text="
							item.category != missionsCategories[1]
								? 'Autre - ' + item.perform
								: item.perform
						"
						v-for="(item, index) in missionsCategories[0]"
						class="w-full"
					/>
				</vs-select>
			</div>
			<div class="vx-col">
				<vs-select
					autocomplete
					v-model="manager_id"
					class="select-large mt-4"
					placeholder="Consultant"
					label="Consultant"
				>
					<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.firstname + ' ' + item.lastname"
						v-for="(item, index) in allConsultantList"
						class="w-full"
					/>
				</vs-select>
			</div>
			<div class="vx-col">
				<div class="mt-4">
					<label for="" class="vs-input--label">Prix</label>
				</div>
				<div><input class="vs-input" v-model="price" /></div>
			</div>
			<div class="vx-col">
				<div class="mt-4">
					<label for="" class="vs-input--label">Quantité</label>
				</div>
				<div><input class="vs-input" v-model="quantity" /></div>
			</div>
			<div class="vx-col">
				<div class="mt-4">
					<label for="" class="vs-input--label">Description</label>
				</div>
				<div>
					<vs-select
						v-model="tva_id"
						class="w-full select-medium mr-2"
						label="% TVA"
						@change="updateItemPrice(index, itemIndex)"
					>
						<vs-select-item
							:key="index"
							:value="row.id"
							:text="row.name"
							v-for="(row, index) in tvaList"
							class="w-full"
						/>
					</vs-select>
				</div>
			</div>
			<div class="vx-col">
				<div class="mt-4">
					<label for="" class="vs-input--label">Description</label>
				</div>
				<div><input class="vs-input" v-model="commentary" /></div>
			</div>
			<div class="vx-col">
				<vs-button :autofocus="true" @click="addItem()" class="mt-5"
					>Enregistrer</vs-button
				>
			</div>
			<div class="vx-col">
				<vs-button @click="showAddInvoiceItem = false" class="mt-5"
					>Annuler</vs-button
				>
			</div>
		</div>
		<div v-else class="vx-row w-full mb-2">
			<vs-button
				:autofocus="true"
				@click="showAddInvoiceItem = true"
				class="mt-5"
				>Ajouter une prestation à facturer</vs-button
			>
		</div>
	</div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";

export default {
	name: "NewInvoiceItemWidget",
	components: {},
	props: {
		missionsCategories: Array,
		index: Number,
		leadId: Number,
		pending_invoice_id: Number,
		tva_id: {
			type: Number,
			default: 0,
		},
	},
	mixins: [dbFieldConvertor, utilsMixin],
	data() {
		return {
			apiUrl: store.state.backendApiUrl,
			product_id: "",
			price: null,
			quantity: 1,
			commentary: "",
			showAddInvoiceItem: false,
			manager_id: this.$props.leadId || 1,
			tvaList: [],
		};
	},
	created() {
		this.getAllTVA();
		this.getAllCollaborators();
	},
	watch: {},
	computed: {
		allConsultantList: () => {
			return store.state.collaborators.filter((collaborator) =>
				[9, 6, 3, 7].includes(collaborator.type)
			);
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
	},
	updated() {},
	methods: {
		getAllTVA() {
			this.$http.get(this.apiUrl + "pending_invoices/tva/all").then((res) => {
				this.tvaList = res.data;
			});
		},
		getAllCollaborators() {
			this.$store.dispatch("getAllCollaborators");
		},

		addItem() {
			let newItem = {
				product_id: this.product_id,
				price: this.price,
				quantity: this.quantity,
				tva_id: this.tva_id,
				commentary: this.commentary,
				index: this.index,
				pending_invoice_id: this.pending_invoice_id,
				manager_id: this.manager_id,
			};

			this.$emit("add-item", newItem);
			this.showAddInvoiceItem = false;
		},
	},
};
</script>

<style>
div.content-tr-expand {
	padding: 0;
}
.loader:after {
	overflow: hidden;
	display: inline-block;
	vertical-align: bottom;
	animation: ellipsis 1.5s infinite;
	content: "......";
	font-weight: bold;
}
@keyframes ellipsis {
	from {
		width: 2px;
	}
	to {
		width: 15px;
	}
}
</style>
